export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系統管理',
  'menu.system.menu': '選單管理',
  'menu.system.user': '用戶管理',
  'menu.system.role': '角色管理',
  'menu.template': '模板示例',
  'menu.login': '登錄',
  'menu.learn': '員工端',
  'menu.learn.home': '學習首頁',
  'menu.learn.center': '學習中心',
  'menu.learn.course': '課程詳情',
  'menu.learn.study-document': '文件學習',
  'menu.learn.study-video': '視頻學習',
  'menu.learn.my-learning': '我的學習',
  'menu.learn.progress': '學習進度',
  'menu.learn.profile': '個人中心',
  'menu.manage': '管理端',
  'menu.manage.workbench': '工作台',
  'menu.manage.course': '課程管理',
  'menu.manage.course-detail': '課程詳情',
  'menu.manage.plan': '學習計劃',
  'menu.manage.plan-create': '新建計劃',
  'menu.manage.plan-detail': '計劃詳情',
  'menu.manage.records': '學習記錄',
  'menu.manage.statistics': '數據看板',
  'menu.manage.permission': '權限管理',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
